import React, { useState, useEffect, useRef } from "react";
import { keyCodeToChar } from "../../../utils";
import { TileInputType } from "../../../types";

const SHIFT = 9;
const TAB = 16;
const BACKSPACE = 8;
const BACK_ARROW = 37;
const FORWARD_ARROW = 39;
const SPACE = 46;
const ENTER = 13;

const TileInput: React.FC<TileInputType> = ({
  letter,
  readOnly,
  onChange,
  onForward,
  onBack,
  focused,
  onSumbit,
  onSetFocus,
}) => {
  const ref = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState<string>("");

  useEffect(() => {
    if (focused && ref.current) {
      ref.current.focus();
    }
  }, [focused]);

  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    let keyCode = e.keyCode;

    if (keyCode === SHIFT || keyCode === TAB) {
      return;
    }
    const charVal = keyCodeToChar(keyCode);

    // alert(keyCode);
    if (keyCode === BACKSPACE && value.length > 0) {
      setValue("");
      onChange("");
    } else if (keyCode === BACKSPACE || keyCode === BACK_ARROW) {
      onBack();
    } else if (keyCode === FORWARD_ARROW || keyCode === SPACE) {
      onForward();
    } else if (keyCode === ENTER) {
      onSumbit();
    }
  };

  const handleChange = (e: any) => {
    // alert(e.target.value);
    onChange(e.target.value);
  };

  return (
    <input
      ref={ref}
      maxLength={1}
      type="text"
      readOnly={readOnly}
      defaultValue={readOnly ? letter : undefined}
      value={!readOnly ? value : undefined}
      onKeyUp={handleKeyUp}
      onChange={handleChange}
      onFocus={(event) => {
        event.target.select();
        onSetFocus();
      }}
    />
  );
};

export default TileInput;
